import React from 'react';
import sharePointLogo from '../../../icons/sharepoint-logo.jpg';
import teamsLogo from '../../../icons/teams-logo.jpg';

const TemplateTypeLogo = ({template}) => {
    return (
        template && 
        <img className='template-site-logo' src={template.siteType === 'Team' ? teamsLogo : sharePointLogo} alt='Template Site type logo' />
    )
}

export default TemplateTypeLogo;


// WEBPACK FOOTER //
// ./src/components/CreateSite/CommonComponents/TemplateTypeLogo.js